import { ShimmerLoader } from './ShimmerLoader';

export const ShimmerLoading = {
	ShimmerLoader,
};
